import request from './config.js'
import drawRequest from './draw.js'

//登陆
export const login = (data) => {   
    return request.post("/users/login", data)
}
//sso登陆
export const ssologin = (params) => {   
    return request.get("/users/login", { params: params })
}
//退出
export const logout = (params) => {   
    return request.get("/users/logout", { params: params })
}
// 用户管理
//用户信息
export const getUserDetail = (params) => {
    return request.get("/users/show_user_self", { params: params })
}
//用户列表
export const userList = (params) => {
      return request.get("/users/list_user", { params: params })
}
//用户权限列表
export const roleList = (params) => {
    return request.get("/users/list_role", { params: params })
}
//创建用户
export const createUser = (data) => {
    return request.post("/users/create_user", data)
}
//修改权限
export const changeRole = (data) => {
    return request.post("/users/change_role", data)
}
//删除用户
export const deleteUser = (data) => {
    return request.post("/users/delete_user",data)
}
//修改密码
export const changePassword = (data) => {
    return request.post("/users/change_password", data)
}

export const getAdStatistics = (params) => {
    return request.get("/ad/statistics", { params: params })
}


// 首页接口

//今日广告投放统计
export const todayPlacementData = (params) => {
    return request.get("/dashboards/show_placement_data_today", { params: params })
}

//今日版位投放列表
export const todayAdList = (params) => {
    return request.get("/dashboards/list_ad_today", { params: params })
}

// 广告版位数据详情
export const homePlacementData = (params) => {
    return request.get("/dashboards/show_placement_data", { params: params })
}

// 广告版位历史流量数据
export const placementHistoryFlow = (params) => {
    return request.get("/dashboards/list_placement_history_flow", { params: params })
}

// 版位流量排行
export const placementFlowRanking = (params) => {
    return request.get("/dashboards/list_placement_flow_ranking", { params: params })
}

// 投放计划流量排行
export const planFlowRanking = (params) => {
    return request.get("/dashboards/list_plan_flow_ranking", { params: params })
}
// 广告管理接口

// 广告列表
export const adList = (params) => {
    return request.get("/advertisements/list_ad", { params: params })
}
//广告详情
export const adDetail = (params) => {
    return request.get("/advertisements/show_ad", { params: params })
}
//新建自营广告
export const createSelfAd = (data) => {
    return request.post("/advertisements/create_self_ad", data)
}
//新建第三方广告
export const createThirdAd = (data) => {
    return request.post("/advertisements/create_third_ad", data)
}
//新建商品广告
export const createProductAd = (data) => {
    return request.post("/advertisements/create_product_ad", data)
}
//修改广告
export const updateAd = (data) => {
    return request.post("/advertisements/update_ad", data)
}
//广告样式列表
export const adTemplateList = (params) => {
    return request.get("/advertisements/list_template", { params: params })
}
//新建广告样式
export const createTemplate = (data) => {
    return request.post("/advertisements/create_template", data)
}
//删除广告
export const deleteTemplate = (data) => {
    return request.post("/advertisements/delete_ad", data)
}
//新建图片弹窗广告
export const createImagePopupAd = (data) => {
    return request.post("/advertisements/create_image_popup_ad", data)
}
//新建文案弹窗广告
export const createTextPopupAd = (data) => {
    return request.post("/advertisements/create_text_popup_ad", data)
}
//修改文案弹窗广告
export const updateTextPopupAd = (data) => {
    return request.post("/advertisements/update_text_popup_ad", data)
}


// 版位管理接口

// 广告位列表
export const placementList = (params) => {
    return request.get("/placements/list_placement", { params: params })
}
// 应用名称列表
export const mediaList = (params) => {
    return request.get("/placements/list_media", { params: params })
}
// 广告位详情
export const placementDetail = (params) => {
    return request.get("/placements/show_placement", { params: params })
}
// 新建广告位
export const createPlacement = (data) => {
    return request.post("/placements/create_placement", data)
}
// 更新广告位
export const updatePlacement = (data) => {
    return request.post("/placements/update_placement", data)
}
// 删除广告位
export const deletePlacement = (data) => {
    return request.post("/placements/delete_placement", data)
}
// 广告位数据详情
export const placementData = (params) => {
    return request.get("/placements/show_placement_data", { params: params })
}
// 广告位上所有投放计划清单
export const placementPlanList = (params) => {
    return request.get("/placements/list_plan_in_placement", { params: params })
}

// 投放管理接口

// 投放计划创建人列表
export const createUserList = (params) => {
    return request.get("/plans/list_created_user", { params: params })
}
//投放计划列表
export const planList = (params) => {
    return request.get("/plans/list_plan", { params: params })
}
//广告可用的版位
export const adPlacementList = (params) => {
    return request.get("/plans/list_placement_all", { params: params })
}
//投放计划详情
export const planDetail = (params) => {
    return request.get("/plans/show_plan", { params: params })
}
//新建投放计划
export const createPlan = (data) => {
    return request.post("/plans/create_plan", data)
}
//修改投放计划
export const updatePlan = (data) => {
    return request.post("/plans/update_plan", data)
}
//删除投放计划
export const deletePlan = (data) => {
    return request.post("/plans/delete_plan", data)
}
//删除投放计划
export const updatePlanStatus = (data) => {
    return request.post("/plans/update_plan_status", data)
}
//投放计划数据详情
export const planStatistics = (params) => {
    return request.get("/plans/show_plan_data", { params: params })
}
//指定广告现有投放计划列表
export const planListByAd = (params) => {
    return request.get("/plans/list_plan_by_ad", { params: params })
}
//批量停止广告投放计划
export const stopPlans = (data) => {
    return request.post("/plans/stop_plan", data)
}
//投放计划操作记录
export const showPlanOperationRecord = (params) => {
    return request.get("/plans/show_plan_operation_record", { params: params })
}
// 可轮换广告列表
export const rotationAdList = (params) => {
    return request.get("/plans/list_rotation_ad", { params: params })
}
// 可ab测广告列表
export const abTestAdList = (params) => {
    return request.get("/plans/list_ab_test_ad", { params: params })
}


// 标签管理

//标签列表
export const labelList = (params) => {
    return request.get("/labels/list_custom_rule", { params: params })
}
//新建标签
export const createLabel = (data) => {
    return request.post("/labels/create_custom_rule", data)
}
//修改标签
export const updateLabel = (data) => {
    return request.post("/labels/update_custom_rule", data)
}
//删除标签
export const deleteLabel = (data) => {
    return request.post("/labels/delete_custom_rule", data)
}
//标签详情
export const labelDetail = (params) => {
    return request.get("/labels/show_custom_rule", { params: params })
}
//可用标签列表
export const activeLabelList = (params) => {
    return request.get("/labels/list_active_custom_rule", { params: params })
}
//修改投放计划的自定义标签
export const updatePlanLabel = (data) => {
    return request.post("/labels/update_plan_label", data)
}
//修改广告位的自定义标签
export const updatePlacementLabel = (data) => {
    return request.post("/labels/update_placement_label", data)
}

// 广告接受人管理
//新增广告接收人
export const createRecipient = (data) => {
    return request.post("/crowds/create_crowd_recipient", data)
}
//删除广告接收人
export const deleteRecipient = (data) => {
    return request.post("/crowds/delete_crowd_recipient", data)
}
//修改标签
export const updateRecipientDesciption = (data) => {
    return request.post("/crowds/update_crowd_recipient_description", data)
}
//标签列表
export const recipientList = (params) => {
    return request.get("/crowds/list_crowd_recipient", { params: params })
}

// 人群管理
//新增人群
export const createCrowd = (data) => {
    return request.post("/crowds/create_crowd", data)
}
//删除广告接收人
export const deleteCrowd = (data) => {
    return request.post("/crowds/delete_crowd", data)
}
//修改标签
export const updateCrowd = (data) => {
    return request.post("/crowds/update_crowd", data)
}
//标签列表
export const crowdList = (params) => {
    return request.get("/crowds/list_crowd", { params: params })
}

// 登录绘画平台获取token
export const drawLogin = (params) => {
    return drawRequest.post("/users/login", params)
}

// 七牛上传凭证
export const getUpToken = (params) => {
    return drawRequest.get("/qiniu/token", { params: params })
}

// 设计模型（AI绘图）
export const submitJimengTask = (params) => {
    return drawRequest.post("/design_model/jimeng/generate", params)
}
export const submitBananaTask = (params) => {
    return drawRequest.post("/design_model/banana/generate", params)
}
export const queryDesignModelTask = (params) => {
    return drawRequest.get("/design_model/task/info", { params: params })
}
export const getDesignModelPaintings = (params) => {
    return drawRequest.get("/design_model/search", { params: params })
}
export const deleteTask = (params) => {
    return drawRequest.post("/design_model/task/delete", params)
}
export const refineADPrompt = (params) => {
    return drawRequest.post("/design_model/ad_prompt/refine", params)
}
export const aiGenerateADPrompt = (params) => {
    return drawRequest.post("/design_model/ad_prompt/ai_generate", params)
}



// WEBPACK FOOTER //
// ./src/request/api.js